import { shape, func } from 'prop-types';

export default shape({
  current: shape({
    getBoundingClientRect: func,
  }),
});
